import {Component} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {ForgotPasswordModalComponent} from '../forgot-password-modal/forgot-password-modal.component';

@Component({
  selector: 'app-session-expiration-modal',
  templateUrl: './session-expiration-modal.component.html',
  styles: []
})
export class SessionExpirationModalComponent {

  constructor(private matDialogRef: MatDialogRef<SessionExpirationModalComponent>) {
    this.matDialogRef.disableClose = true;
  }

  close() {
    this.matDialogRef.close('logout')
  }

}
